module.exports = __webpack_public_path__ + "static/img/qa.fb8a8154.svg";